// quotation-preview Header.js
import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { styles } from "../styles";
import { COMPANY_LOGO_URL, COMPANY_PREFIX } from "../../config/config";

const Header = ({ quotationData }) => {
  const companyName = COMPANY_PREFIX;
  const logoUrl = COMPANY_LOGO_URL;

  const year = new Date(quotationData.documentDate).getFullYear();
  const documentNo = `${companyName}(${quotationData.type})-${year}-${quotationData.runNumber}`;
  const { clientDetails } = quotationData;

  // ⭐ ป้องกันโดนตัดตัวท้าย (Zero Width Space)
  const safe = (txt = "") => txt + "\u200B";

  return (
    <View>
      {/* ส่วนหัวของใบเสนอราคา */}
      <View style={styles.header}>
        <View style={styles.logoContainer}>
          {logoUrl && <Image src={logoUrl} style={styles.logo} />}
        </View>
        <View style={styles.headerContent}>
          <Text style={styles.headerTitle}>ใบเสนอราคา</Text>
          <Text style={styles.headerTitleBold}>QUOTATION</Text>
        </View>
      </View>

      {/* รายละเอียดลูกค้าและใบเสนอราคา */}
      <View style={styles.headerDetailsWrapper}>
        <View style={styles.clientDetailsContainer}>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Customer Name:</Text>
            <Text style={styles.value}>
              {safe(clientDetails?.customerName || "N/A")}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Address:</Text>
            <Text style={[styles.value, styles.multiline]}>
              {safe(clientDetails?.address || "N/A")}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Tax ID:</Text>
            <Text style={styles.value}>
              {clientDetails?.taxIdentificationNumber || "N/A"}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Contact:</Text>
            <Text style={styles.value}>
              {clientDetails?.contactPhoneNumber || "N/A"}
            </Text>
          </View>
        </View>

        <View style={styles.headerDetailsContainer}>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Document No.:</Text>
            <Text style={styles.value}>{documentNo}</Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Document Date:</Text>
            <Text style={styles.value}>
              {new Date(quotationData.documentDate).toLocaleDateString("en-GB")}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Salesperson:</Text>
            <Text style={styles.value}>{quotationData.salePerson || "-"}</Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Project Name:</Text>
            <Text style={styles.value}>
              {safe(quotationData.projectName || "-")}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Project Run:</Text>
            <Text style={styles.value}>
              {safe(quotationData.period || "-")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Header;
